<template>
    <bc-dialog
        :value="entity_address_dialog"
        :content-class="{ 'd-none': !object_ref }"
        :hide-overlay="!object_ref"
    >
        <v-card>
            <v-card-title>
                <span class="headline">{{ entity_address.entity_addresses_id ? hasScope('update') ? $t('lang.editAddress') : $t('lang.entity_address_details') : $t('lang.addAddress') }}</span>
                <v-spacer></v-spacer>
                <bc-btn-dialog-close
                    @invoke-method="invokeMethod($event)"
                    :dialog-status="entity_address_dialog"
                    action="close"
                ></bc-btn-dialog-close>
            </v-card-title>
            <v-card-text>
                <v-form ref="entity_address">
                    <v-container grid-list-form>
                        <v-layout row wrap>
                            <v-flex xs12 pr-0>
                                <v-layout row>
                                    <v-flex xs6 class="primary-chip-container inner-flex" v-if="entity_address.prime">
                                        <v-chip
                                            v-if="entity_address.prime == '1'"
                                            color="primary"
                                            class="primary-chip"
                                            disabled
                                        >
                                            {{ $t('lang.primary_caps') }}
                                        </v-chip>
                                        <v-switch
                                            v-else
                                            v-model="entity_address.prime"
                                            :label="$t('lang.primary')"
                                            true-value="1"
                                            false-value="0"
                                        ></v-switch>
                                    </v-flex>
                                    <bc-btn-entity-action
                                        v-if="entity_address.full_single_line_address"
                                        class="ml-auto"
                                        icon="content_copy"
                                        text="Copy"
                                        @action="copyContent(entity_address.full_single_line_address)"
                                    ></bc-btn-entity-action>
                                    <bc-btn-entity-action
                                        v-if="entity_address.maps_link"
                                        icon="pin_drop"
                                        :text="$bp.xsOnly ? $t('lang.directions') : $t('lang.show_map')"
                                        :currentEntity="entity_address"
                                        :link="entity_address.maps_link"
                                    ></bc-btn-entity-action>
                                </v-layout>
                            </v-flex>
                            <v-flex xs7 v-if="object_ref == 'companies'">
                                <v-text-field
                                    v-model="entity_address.location_label"
                                    :label="`${$t('lang.location_label')}`"
                                    :counter="showCounter(entity_address.location_label, 'entity_address.location_label')"
                                    :rules="ifValid('entity_addresses.location_label')"
									:readonly="!hasScope('update')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex :class="object_ref == 'companies' ? 'xs5' : 'xs12'">
                                <bc-select
                                    v-model="entity_address.address_type"
                                    :label="`${$t('lang.address_type')} *`"
                                    :items="AddressTypes"
                                    :propsMenu="{ top: true }"
                                    :rules="ifValid('entity_addresses.address_type')"
									:readonly="!hasScope('update')"
                                >
                                    <template slot="item" slot-scope="data">
                                        {{ $t(`lang.${data.item}`) }}
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                        {{ $t(`lang.${data.item}`) }}
                                    </template>
                                </bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="entity_address_dialog"
                                    v-model="entity_address.address1"
                                    :label="`${$t('lang.address1')} *`"
                                    :counter="showCounter(entity_address.address1, 'entity_address.address1')"
                                    :rules="ifValid('entity_addresses.address1')"
									:readonly="!hasScope('update')"
                                >
                                    <template slot="append-outer">
                                        <bc-tooltip :disabled="has_alt_address">
                                            <template slot="activator">
                                                <v-btn icon @mouseup.left="has_alt_address = true" tabindex="-1" :class="{ 'd-none': has_alt_address }">
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t('lang.add_another_address') }}
                                        </bc-tooltip>
                                    </template>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="has_alt_address">
                                <v-text-field
                                    v-model="entity_address.address2"
                                    :label="$t('lang.address2')"
                                    :counter="showCounter(entity_address.address2, 'entity_address.address2')"
                                    :rules="ifValid('entity_addresses.address2')"
									:readonly="!hasScope('update')"
                                >
                                    <template slot="append-outer">
                                        <bc-tooltip>
                                            <template slot="activator">
                                                <v-btn icon @mouseup.left="has_alt_address = false" tabindex="-1">
                                                    <v-icon>remove</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t('lang.remove') }}
                                        </bc-tooltip>
                                    </template>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="entity_address.zip_code"
                                    :label="`${$t('lang.zip_code')} *`"
                                    @input="getZipCode"
                                    :counter="showCounter(entity_address.zip_code, 'entity_address.zip_code')"
                                    :rules="ifValid('entity_addresses.zip_code')"
									:readonly="!hasScope('update')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    v-model="entity_address.city"
                                    :label="`${$t('lang.city')} *`"
                                    :counter="showCounter(entity_address.city, 'entity_address.city')"
                                    :rules="ifValid('entity_addresses.city')"
									:readonly="!hasScope('update')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    v-model="entity_address.state"
                                    :label="`${$t('lang.state')} *`"
                                    :counter="showCounter(entity_address.state, 'entity_address.state')"
                                    :rules="ifValid('entity_addresses.state')"
									:readonly="!hasScope('update')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="entity_address.country_id"
                                    :label="`${$t('lang.country_id')} *`"
                                    :initial="entity_address.country_name"
                                    :items="countries"
                                    item-value="country_id"
                                    item-text="country_name"
                                    :rules="ifValid('entity_addresses.country_id')"
                                    :propsMenu="{ top: true }"
									:readonly="!hasScope('update')"
                                ></bc-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
                <delete-confirmation-dialog
                    ref="delete_entity_address"
                    :heading="$t('lang.delete_entity_address')"
                    :message="$t('lang.confirm_delete_message')"
                    @onConfirm="deleteAddress()"
                >
                    <v-form ref="delete_confirm_address" @submit.prevent>
                        <bc-autocomplete
                            v-if="prime && entity_address.prime == '1' && entity_address.entity_addresses_id"
                            v-model="new_prime_entity_addresses_id"
                            :label="`${$t('lang.new_primary_address')} *`"
                            :items="availableItems"
                            item-value="entity_addresses_id"
                            item-text="full_single_line_address"
                            :rules="ifValid('entity_addresses.new_prime_entity_addresses_id')"
                        ></bc-autocomplete>
                    </v-form>
                </delete-confirmation-dialog>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="hasScope('delete') && entity_address.entity_addresses_id && (!prime || availableItems.length > 0)" color="error" @mouseup.left="$refs.delete_entity_address.openDialog()">{{ $t('lang.delete') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn flat @mouseup.left="close()">{{$t('lang.cancel')}}</v-btn>
                <v-btn
                    v-if="entity_address.entity_addresses_id ? hasScope('update') : hasScope('create')"
                    color="success"
                    @mouseup.left="saveAddress()"
                >
                    {{$t('lang.save')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </bc-dialog>
</template>
<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import _ from "lodash";

export default {
    props: {
        object_ref: {
            // object name matching first portion of api url i.e. people | me | customers
            type: String,
            required: true,
        },
        object_id: {
            type: [String, Number],
        },
        total_items: {
            // to decide if a new address needs to be prime
            type: [Array, Object],
        },
        scope: {
            // scope from parent
            type: [String],
            default: null,
        },
        prime: {
            // whether to include a prime switch
            type: Boolean,
            default: true,
        },
        address_type: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            entity_address: {
                prime: "",
                object_ref: "",
                object_id: "",
            },
            entity_address_dialog: false,
            AddressTypes: ["billing", "shipping", "work", "other"],
            countries: null,
            new_prime_entity_addresses_id: null,
            has_alt_address: false,
        };
    },
    computed: {
        ...mapState({
            rules_entity_addresses: (state) => state.entity_addresses.rules_entity_addresses,
        }),
        availableItems() {
            let items = [];
            if (this.total_items && this.total_items.length > 1) {
                return this.total_items.filter((item) => item.entity_addresses_id != this.entity_address.entity_addresses_id);
            }
            return items;
        },
        hasScope() {
            return (scope) => {
                return !this.scope || this.scope.includes(`${scope}`) || !this.entity_address.entity_addresses_id;
            };
        },
    },
    mounted: function() {
        // manually throw vue warning since dynamically setting object_ref as 'required: true/false' is not possible
        if (typeof this.object_ref == "undefined" && typeof this.object_id !== "undefined") {
            throw new Error('Missing required prop: "object_ref" OR "object_id""');
        }
    },
    methods: {
        close() {
            this.new_prime_entity_addresses_id = null;
            this.entity_address_dialog = false;
            this.$refs.delete_entity_address.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getCountries() {
            this.$store
                .dispatch("fetchLocale", {
                    url: "locales/countries",
                    method: "get",
                    stateProperty: "locale_countries",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.countries = data.locale_countries;
                    }
                });
        },
        saveAddress() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("entity_address")) {
                    this.$store.commit("toggleModalLoader", true);

                    let body = this.prepForm(this.entity_address, this.rules_entity_addresses);

                    this.$store
                        .dispatch("saveEntityAddress", {
                            body: body,
                        })
                        .then((data) => {
                            if (typeof data != "undefined" && data.code == "200") {
                                this.$emit("eventname", data.entity_addresses);
                                this.close();
                            } else {
                                this.$store.commit("toggleModalLoader", false);
                            }
                        });
                }
            });
        },
        deleteAddress() {
            this.$store.commit("validationOn");

            this.$nextTick(() => {
                if (this.validateForm("delete_confirm_address")) {
                    let id = this.entity_address.entity_addresses_id ? { entity_addresses_id: this.entity_address.entity_addresses_id } : NULL;

                    this.$store
                        .dispatch("deleteEntityAddress", {
                            id: this.entity_address.entity_addresses_id,
                            new_prime_entity_addresses_id: this.new_prime_entity_addresses_id ? this.new_prime_entity_addresses_id : null,
                        })
                        .then((data) => {
                            if (typeof data != "undefined" && data.code == "200") {
                                this.$emit("eventname", data.entity_addresses);
                                this.close();
                            } else {
                                this.$store.commit("toggleModalLoader", false);
                            }
                            this.$store.commit("toggleModalLoader", false);
                        });
                }
            });
        },
        showAddress(item = null) {
            this.entity_address = !item ? { object_ref: this.object_ref, object_id: this.object_id } : this.assignObj2(item, this.rules_entity_addresses);
            if (this.countries == null) this.getCountries();
            if (this.$refs.entity_address) item ? this.$refs.entity_address.resetValidation() : this.$refs.entity_address.reset();

            this.$nextTick(() => {
                if (this.address_type) this.entity_address.address_type = this.address_type;
                this.has_alt_address = !!this.entity_address.address2;
                this.entity_address_dialog = true;
            });
        },
        getZipCode() {
            if ((this.entity_address.zip_code || "").length == 5) {
                this.$store.commit("toggleModalLoader", true);

                this.$store
                    .dispatch("fetchLocale", {
                        url: "locales/postal_codes/" + this.entity_address.zip_code,
                        method: "get",
                        stateProperty: "postal_code",
                        commit: true,
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.locale_postal_codes) {
                            this.entity_address.city = data.locale_postal_codes.city;
                            this.entity_address.state = data.locale_postal_codes.state;
                            this.entity_address.country_id = data.locale_postal_codes.country_id;
                        }
                    })
                    .finally(() => this.$store.commit("toggleModalLoader", false));
            }
        },
        copyContent: _.debounce(
            function(copyMsg) {
                var copyText = copyMsg;
                let el = document.createElement("textarea");
                el.innerHTML = copyText;
                let type = "text/plain";
                let blob = new Blob([el.value], { type });
                let data = [new ClipboardItem({ [type]: blob })];
                navigator.clipboard.write(data);
                this.createAlert("success", "text_copied");
            },
            1500,
            { maxWait: 1500, leading: true, trailing: false }
        ),
    },
};
</script>
